import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';

export const materialSerialNumberNodeCfgSchema = baseNodeCfgSchema.extend({
    kind: z.literal('materialSerialNumber'),
});
export interface MaterialSerialNumberNodeCfgSchema extends z.infer<typeof materialSerialNumberNodeCfgSchema> {}

export const materialSerialNumberNodeSocketCfg = {
    controlSockets: {
        inputs: () => ({ trigger: 'event' }),
        outputs: () => ({ next: 'event' }),
    },
    dataSockets: {
        inputs: () => ({ materialId: 'string' }),
        outputs: () => ({ serialNumber: 'string' }),
    },
} satisfies NodeSocketCfg<MaterialSerialNumberNodeCfgSchema>;
